export default __webpack_public_path__ + "static/media/procode.b2f04835.jpg";